<template>
    <div class="group-view relative bg-theme-gray w-full flex h-auto ">
        <CategoryList :list="state"></CategoryList>
        <div class="w-[calc(100%-16rem)] h-auto pt-12 pb-40 flex flex-col items-center item-body">
            <div class="informationGroup">
                <section class="infowidth w-780 mb-5">
                    <p class="text-sm text-txt-lightgray"><router-link class="hover:underline" to="/">HOME</router-link> >
                        <router-link class="hover:underline"
                            :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: category_param } }">{{
                                category_name }}</router-link>
                        > <span class="text-txt-gray">{{ state.cassette_block_name }}</span>
                    </p>
                </section>
                <!-- Group注記文 -->
                <section>
                    <p class="cautionwordGroup text-txt-gray">※表示価格はカタログ掲載価格です。<br><br>※商品名に■マークがある商品は<br>イチオシ家具カタログ掲載品です。
                    </p>
                </section>
                <!-- Group注記文ここまで -->
            </div>
            <section class="bg-theme-white w-780">
                <div class="w-full p-5 flex">
                    <div class="w-1/4">
                        <!--<img class="object-fill w-full h-full" src="@/assets/fita.svg">-->
                        <img class="object-fill w-full h-full cursor-pointer" :src="img_path + state.cassette_img01"
                            @click="openModal(index)">
                        <GroupModal :flag="imgFlag" v-show="showContent" @close="closeModal" />
                    </div>
                    <div class="w-3/4">
                        <div class="flex justify-between h-auto items-start">
                            <div class="pl-5">
                                <h1 class="text-xl">{{ state.cassette_block_name }}</h1>
                                <!--<h1 class="text-3xl">{{test2}}</h1>-->

                                <p class="text-xs">メーカー：{{ state.maker_name }}</p>
                            </div>
                            <div class="">
                                <ul>
                                    <li v-if="state.other_link_name === '飛沫防止パネル比較表'"
                                        class="flex justify-center mb-1 bg-theme-gray rounded text-txt-black text-xs hover:opacity-70 transition uration-300">
                                        <a class="flex items-center h-full justify-between p-2"
                                            href="https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/himatsubousi_panel_hikaku.pdf"
                                            target="_blank">飛沫防止パネル比較表<span class="pl-2">>></span></a>
                                    </li>
                                    <li v-if="state.other_link_name === '取付け確認資料'"
                                        class=" bg-theme-gray rounded text-txt-black text-xs hover:opacity-70 transition uration-300">
                                        <a class="flex items-center h-full justify-between p-2"
                                            href="https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/common/armhandle_toritsuke.pdf"
                                            target="_blank">取り付け上の注意<span class="pl-2">>></span></a>
                                    </li>
                                    <li v-if="state.other_link_name === '組み合わせ例・設置上の注意'"
                                        class=" bg-theme-gray rounded text-txt-black text-xs hover:opacity-70 transition uration-300">
                                        <a class="flex items-center h-full justify-between p-2"
                                            href="https://www.jointex.co.jp/p-layout/lf/jklayout.html"
                                            target="_blank">組み合わせ例・設置上の注意<span class="pl-2">>></span></a>
                                    </li>
                                    <li v-else class="hidden"><a class="flex items-center h-full justify-between p-2"
                                            href=""><span class="pl-2"></span></a></li>
                                </ul>
                            </div>
                        </div>
                        <p class="pl-5 pt-2 text-sm text-txt-gray">
                            {{ state.cassette_comment01 }}<br>{{ state.cassette_comment02 }}</p>
                        <div class="pl-5 pt-2 flex">
                            <article class="w-20 h-20 mr-2">
                                <img v-if="state.cassette_img02 === ' ' || state.cassette_img02 === ''" class="hidden">
                                <img v-else :src="img_path + state.cassette_img02" class="border border-bd-gray">
                            </article>
                            <article class="w-20 h-20 mr-2">
                                <img v-if="state.cassette_img03 === ' ' || state.cassette_img03 === ''" class="hidden">
                                <img v-else :src="img_path + state.cassette_img03" class="border border-bd-gray">
                            </article>
                            <article class="w-20 h-20 mr-2">
                                <img v-if="state.cassette_img04 === ' ' || state.cassette_img04 === ''" class="hidden">
                                <img v-else :src="img_path + state.cassette_img04" class="border border-bd-gray">
                            </article>

                        </div>
                    </div>
                </div>
                <p class="p-5 text-xs text-txt-red">{{ state.cassette_comment03 }}</p>
                <div class="px-5 mb-5">
                    <div class="mb-5 table_st" v-for="(b_body, index) in state.b_body_arr" :key=index>
                        <h4 class="font-bold text-base text-txt-black">{{ b_body.key_title }}</h4>

                        <table class="">
                            <thead>
                                <tr class="head text-xs text-txt-gray">
                                    <td class="w-16 px-2"></td>
                                    <td class="w-24 px-2">商品コード</td>
                                    <td class="w-56 px-2">商品名</td>
                                    <td class="w-32 px-2">種別</td>
                                    <td class="w-28 px-2">価格（税抜）</td>
                                    <td class="w-28 px-2">価格（税込）</td>
                                </tr>
                            </thead>
                            <tr class="tr_st" v-for="item in b_body.key_body" :key="item.id">
                                <td class=""><img class="p-1" :src="img_path + item.web_img01"></td>
                                <td class="w-20 px-2 text-sm text-txt-gray relative">
                                    {{ item.ichioshi_product_code }}
                                    <SoldOut v-if="item.sold_out_cd == '1'"></SoldOut>
                                    <!--<SoldOut v-else class="hidden"></SoldOut>-->
                                </td>
                                <td class="w-40 px-2 text-sm text-txt-gray"><a :href="item.product_url"
                                        class="underline text-txt-link" @click="handleClick">{{ item.product_name }}</a>
                                </td>
                                <!-- <td class="w-40 px-2 text-sm text-txt-gray"><router-link class="underline text-txt-link" @click="handleClick" :to="{name:'Product',query:{operationtype:'product',webcat_view:item.webcat_view,cassette_id:item.cassette_id,ichioshi_product_code:item.ichioshi_product_code}}">{{ item.product_name }}</router-link></td> -->
                                <td class="w-28 px-2 text-sm text-txt-gray" v-html="item.kinds"></td>
                                <td class="w-28 px-2 text-sm text-txt-red">{{ Number(item.price_off).toLocaleString() }}円
                                </td>
                                <td class="w-28 px-2 text-sm text-txt-red">{{ Number(item.price_on).toLocaleString() }}円
                                </td>
                            </tr>
                        </table>
                    </div>

                    <!--<h4 class="font-bold text-base text-txt-black">{{state.cassette_block_name}}</h4>-->
                    <!--<table>-->
                    <!--    <thead>-->
                    <!--        <tr class="head text-xs text-txt-gray">-->
                    <!--            <td class="w-16 px-2"></td>-->
                    <!--            <td class="w-24 px-2">商品コード</td>-->
                    <!--            <td class="w-56 px-2">商品名</td>-->
                    <!--            <td class="w-32 px-2">種別</td>-->
                    <!--            <td class="w-28 px-2">価格（税抜）</td>-->
                    <!--            <td class="w-28 px-2">価格（税込）</td>-->
                    <!--        </tr>-->
                    <!--    </thead>-->
                    <!--    <tbody class="">-->
                    <!--        <tr class="odd:bg-theme-gray even:bg-theme-white" v-for="item in state.items" :key="item.id">-->
                    <!--            <td class=""><img class="p-1" :src="img_path + item.web_img01"></td>-->
                    <!--            <td class="w-20 px-2 text-sm text-txt-gray relative">-->
                    <!--                {{ item.ichioshi_product_code }}-->
                    <!--                <SoldOut v-if="item.sold_out_cd === '1'"></SoldOut>-->
                    <!--<SoldOut v-else class="hidden"></SoldOut>-->
                    <!--            </td>-->
                    <!--            <td class="w-40 px-2 text-sm text-txt-gray"><router-link class="underline text-txt-link" @click="handleClick" :to="{name:'Product',query:{operationtype:'product',webcat_view:item.webcat_view,cassette_id:item.cassette_id,ichioshi_product_code:item.ichioshi_product_code}}">{{ item.product_name }}</router-link></td>-->
                    <!--            <td class="w-28 px-2 text-sm text-txt-gray" v-html="item.kinds"></td>-->
                    <!--            <td class="w-28 px-2 text-sm text-txt-red">{{ Number(item.price_off).toLocaleString() }}円</td>-->
                    <!--            <td class="w-28 px-2 text-sm text-txt-red">{{ Number(item.price_on).toLocaleString() }}円</td>-->
                    <!--        </tr>-->
                    <!--    </tbody>-->
                    <!--</table>-->
                </div>
            </section>
            <section class="w-780 mt-5 mb-10">
                <p class="text-sm text-txt-lightgray"><router-link class="hover:underline" to="/">HOME</router-link> >
                    <router-link class="hover:underline"
                        :to="{ name: 'Category', query: { operationtype: 'category', webcat_view: category_param } }">{{
                            category_name }}</router-link>
                    > <span class="text-txt-gray">{{ state.product_name }}</span>
                </p>
            </section>
        </div>
    </div>
    <Footer></Footer>
</template>
<script>
import Footer from '@/components/Footer.vue';
import GroupModal from '@/components/GroupModal.vue';
import CategoryList from '@/components/CategoryList.vue';
import SoldOut from '@/components/kanbai.vue';
import { useRoute } from 'vue-router'
import { ref, watchEffect, reactive } from 'vue';
import axios from 'axios'
import { search_json } from '@/json.config.js';

export default {
    components: {
        SoldOut,
        GroupModal,
        CategoryList,
        Footer
    },
    methods: {
        handleClick: function () {
            window.scroll({ top: 0, behavior: 'smooth' });
        }
    },
    name: 'groupview',

    setup() {
        const route = useRoute()
        const category_param = ref(route.query.webcat_view)
        const group_id = ref(route.query.cassette_id)
        let url = ref('');
        const img_path = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/img/500/"
        let category_name = ref('')

        const group_items = ref([])

        watchEffect(() => {
            category_param.value = route.query.webcat_view
            group_id.value = route.query.cassette_id
            group_items.value = []

            // クエリパラメーターからカテゴリ名を作成
            switch (category_param.value) {
                case 'Outlet':
                    category_name.value = 'アウトレット'
                    break
                // case 'Prevention':
                //     category_name.value = '感染対策用品'
                //     break
                case 'Accessory':
                    category_name.value = 'アクセサリー'
                    break
                case 'Desk':
                    category_name.value = 'デスク・デスク周辺'
                    break
                case 'Table':
                    category_name.value = 'テーブル'
                    break
                case 'Chair':
                    category_name.value = 'チェア'
                    break
                case 'Lobby':
                    category_name.value = '応接・ロビー'
                    break
                case 'MeetingChair':
                    category_name.value = 'ミーティングチェア'
                    break
                case 'Partition':
                    category_name.value = 'パーティション'
                    break
                case 'Board':
                    category_name.value = 'ボード'
                    break
                case 'Storage':
                    category_name.value = '収納'
                    break
                case 'Counter':
                    category_name.value = 'カウンター'
                    break
                // case 'Emergency':
                //     category_name.value = '防災用品'
                //     break
                case 'Education':
                    category_name.value = '教育・保育施設'
                    break
                case 'Medical':
                    category_name.value = '医療・福祉施設'
                    break
                default:
                    category_name.value = ''
                    break
            }

        })

        console.log(url)
        const state = reactive({
            data: null,
            items: null,
            cassette_block: null,
            product_name: null,
            maker_name: null,
            cassette_comment01: null,
            cassette_comment02: null,
            cassette_comment03: null,
            cassette_img01: null,
            cassette_img02: null,
            cassette_img03: null,
            cassette_img04: null,
            b_body_arr: null,
        })

        watchEffect(() => {
            url = "https://666wcb198b.execute-api.ap-northeast-1.amazonaws.com/resource/query?operationtype=group&webcat_view=" + category_param.value + "&cassette_id=" + group_id.value;

            // const search_json = "https://ichioshi-s3.s3.ap-northeast-1.amazonaws.com/json/search2023_so.json"
            async function getitems() {
                const all_data = await axios.get(search_json)
                const c_i_block_name = [];//add0818
                // console.log(all_data)
                all_data.data.forEach(function (value) {
                    if (value.webcat_view === category_param.value && value.cassette_id === group_id.value) {
                        group_items.value.push(value)
                        c_i_block_name.push(value.cassette_included_block_name);//add0818
                    }
                })
                // state.data = await axios.get(url)

                // state.items = state.data.data.Items.reverse()
                state.items = group_items.value
                // console.log(group_items.value)

                state.cassette_id = state.items[0].cassette_id
                state.webcat_view = state.items[0].webcat_view
                state.cassette_block_name = state.items[0].cassette_block_name
                state.product_name = state.items[0].product_name;
                state.maker_name = state.items[0].maker_name;
                state.cassette_comment01 = state.items[0].cassette_comment01;
                state.cassette_comment02 = state.items[0].cassette_comment02;
                state.cassette_comment03 = state.items[0].cassette_comment03;
                state.cassette_img01 = state.items[0].cassette_img01;
                state.cassette_img02 = state.items[0].cassette_img02;
                state.cassette_img03 = state.items[0].cassette_img03;
                state.cassette_img04 = state.items[0].cassette_img04;
                state.maker_name = state.items[0].maker_name;
                state.other_link_url = state.items[0].other_link_url
                state.other_link_name = state.items[0].other_link_name
                state.sold_out_cd = state.items[0].sold_out_cd

                //タイトル変更
                document.title = state.cassette_block_name + "｜イチオシ";

                //ページ下部のグループ一覧を作る add0818
                //cassette_included_block_nameの重複排除しリスト化
                const set = new Set(c_i_block_name);
                const c_i_block_nameArr = [...set];
                // console.log(c_i_block_nameArr)

                // 同じcassette_included_block_name
                let bottomHTML = []
                let all_bottomHTML = []

                for (let i = 0; i < c_i_block_nameArr.length; i++) {
                    bottomHTML = []
                    // console.log(c_i_block_nameArr[i])
                    state.items.filter(value => {
                        // console.log(value.cassette_included_block_name)
                        if (value.cassette_included_block_name.indexOf(c_i_block_nameArr[i]) !== -1) {
                            bottomHTML.push(value)
                        }
                    });
                    all_bottomHTML.push({ key_title: c_i_block_nameArr[i], key_body: bottomHTML })
                }

                // console.dir(value.cassette_included_block_name)
                console.dir(all_bottomHTML);
                // group_items.value.forEach(function(value) {
                //     // group_items.value.push(value)
                // })
                state.b_body_arr = all_bottomHTML
            }
            getitems()

        })


        // 画像クリックでモーダル表示
        const showContent = ref()
        const imgFlag = ref(0)
        const openModal = (index) => {
            showContent.value = true
            // console.log(index)
            imgFlag.value = index
        }

        const closeModal = () => {
            showContent.value = false
        }

        return {
            category_param,
            category_name,
            watchEffect,
            state,
            img_path,
            showContent,
            imgFlag,
            openModal,
            closeModal
        }
    }
}
</script>